<template>
  <div class="mx-auto py-4">
    <v-card class="mx-4 my-2" flat>
      <v-card-title>
        Monitoring Report
        <v-spacer></v-spacer>
        <div class="ml-12">
          <download-excel
              :data="selected"
              :fields="exportFields"
              name="MonitoringReport.xls"
              type="csv"
          >
            <v-btn class="teal white--text" color="primary" dark depressed small>
              <v-icon left>mdi-export</v-icon>
              <span>Export</span>
            </v-btn>
          </download-excel>
        </div>
      </v-card-title>

      <v-data-table
          v-model="selected"
          :headers="headers"
          :items="monitoringReports.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="monitoringReports.count"
          class="elevation-1"
          item-key="id"
          loading-text="Loading... please wait"
          show-select
      >
        <template v-slot:top>
          <v-layout class="p-3" row wrap>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="preServiceLevelValue"
                  :clearable="clearable"
                  :items="PRE_SERVICE_LEVELS"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="name"
                  label="Pre Service Level"
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs3>
              <v-autocomplete
                  v-model="universityValue"
                  :clearable="clearable"
                  :items="UNIVERSITIES"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Higher Learning Institution"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs3>
              <v-autocomplete
                  v-model="programValue"
                  :clearable="clearable"
                  :items="EDUCATIONAL_PROGRAMS"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Program Type"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="disciplineValue"
                  :clearable="clearable"
                  :items="DISCIPLINES"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Discipline"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-autocomplete
                  v-model="yearOfEducValue"
                  :clearable="clearable"
                  :items="YEAR_OF_EDUCATION"
                  :loading="lookupLoading"
                  item-text="name"
                  item-value="id"
                  label="Year of Education"
                  return-object
              ></v-autocomplete>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-layout class="p-3" row wrap>
                <v-flex xs7>
                  <v-text-field
                      v-model="maleValue"
                      label="No. of Male"
                      type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex style="margin-top: 10px" xs5>
                  <v-select
                      v-model="maleComparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-layout class="p-3" row wrap>
                <v-flex xs7>
                  <v-text-field
                      v-model="femaleValue"
                      label="No. of Female"
                      type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex style="margin-top: 10px" xs5>
                  <v-select
                      v-model="femaleComparisonValue"
                      :items="comparisons"
                      class="comparisonSelect"
                      dense
                      item-text="name"
                      item-value="value"
                      solo
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-select
                  v-model="dateRangePreset"
                  :items="dateRangePresets"
                  item-text="text"
                  item-value="value"
                  clearable
                  label="Quick Range"
              ></v-select>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-select
                  v-model="dateRangeYear"
                  :items="dateRangeYears"
                  clearable
                  label="Year"
              ></v-select>
            </v-flex>
            <v-flex v-if="dateRangePreset && dateRangePreset !== 'yearly'" class="p-2" xs2>
              <v-select
                  v-model="dateRangePeriod"
                  :items="getPresetPeriodOptions(dateRangePreset)"
                  :disabled="!dateRangePreset || dateRangePreset === 'yearly'"
                  clearable
                  label="Period"
              ></v-select>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu
                  ref="startMenu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="startDateValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="Start Date"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="startDateValue"
                    no-title
                    scrollable
                    @input="startMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex class="p-2" xs2>
              <v-menu
                  ref="endMenu"
                  v-model="endMenu"
                  :close-on-content-click="false"
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="endDateValue"
                      :clearable="true"
                      persistent-hint
                      placeholder="End Date"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="endDateValue"
                    no-title
                    scrollable
                    @input="endMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {getDisciplines, getEducationalPrograms, getUniversities} from "@/utils/helper";
import {PreServiceReportService} from "@/components/Reports/preservice-report/pre-service-report-service";
import {EducLevelEnum, YearOfEducEnum} from "@/utils/enums";
import reportDateRangeMixin from "@/mixins/reportDateRangeMixin";

export default {
  mixins: [reportDateRangeMixin],
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      monitoringReports: {
        rows: [],
        count: 0,
      },
      headers: [
        {text: "Higher Learning Institution", value: "university.name"},
        {text: "Pre Service Level", value: "preServiceLevel"},
        {text: "Program Type", value: "educationProgram.name"},
        {text: "Discipline", value: "discipline.name"},
        {text: "Year Of Education", value: "entryYear"},
        {text: "No. of Male", value: "noOfMale"},
        {text: "No. of Female", value: "noOfFemale"},
        {text: "Total Count", value: "totalCount"},
      ],
      exportFields: {
        "Higher Learning Institution": "university.name",
        "Pre Service Level": "preServiceLevel",
        "Program Type": "educationProgram.name",
        "Discipline": "discipline.name",
        "Year Of Education": "entryYear",
        "No. of Male": "noOfMale",
        "No. of Female": "noOfFemale",
        "Total Count": "totalCount",
      },
      selected: [],

      PRE_SERVICE_LEVELS: [],
      UNIVERSITIES: [],
      EDUCATIONAL_PROGRAMS: [],
      DISCIPLINES: [],
      allDisciplines: [],
      YEAR_OF_EDUCATION: [],

      lookupLoading: false,
      clearable: true,
      loading: false,

      preServiceLevelValue: null,
      universityValue: null,
      programValue: null,
      disciplineValue: null,
      yearOfEducValue: null,
      maleValue: null,
      femaleValue: null,
      startDateValue: null,
      endDateValue: null,
      startMenu: false,
      endMenu: false,
      dateRangePreset: null,
      dateRangeYear: null,
      dateRangePeriod: null,

      currentYear: new Date().getFullYear(),
      comparisons: [
        {name: "=", value: "eq"},
        {name: "<", value: "lt"},
        {name: ">", value: "gt"},
        {name: "<=", value: "lte"},
        {name: ">=", value: "gte"},
      ],
      maleComparisonValue: null,
      femaleComparisonValue: null,
    };
  },
  async beforeMount() {
    await this.fetchMonitoringReports();
    await this.initiateLookups();
  },
  watch: {
    options: {
      handler() {
        this.fetchMonitoringReports();
      },
      deep: true,
    },
    preServiceLevelValue() {
      this.fetchMonitoringReports();
    },
    universityValue() {
      this.fetchMonitoringReports();
    },
    programValue(val) {
      this.programValue = val === "" ? null : val;
      this.fetchOnFilters();
      this.fetchMonitoringReports();
    },
    disciplineValue(val) {
      this.disciplineValue = val === "" ? null : val;
      this.fetchMonitoringReports();
    },
    yearOfEducValue(val) {
      this.yearOfEducValue = val === "" ? null : val;
      this.fetchMonitoringReports();
    },
    maleValue() {
      this.fetchMonitoringReports();
    },
    maleComparisonValue() {
      this.fetchMonitoringReports();
    },
    femaleValue() {
      this.fetchMonitoringReports();
    },
    femaleComparisonValue() {
      this.fetchMonitoringReports();
    },
    startDateValue() {
      this.fetchMonitoringReports();
    },
    endDateValue() {
      this.fetchMonitoringReports();
    },
    dateRangePreset(val) {
      this.applyPresetWithSelection(val, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
    },
    dateRangeYear() {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
    dateRangePeriod() {
      if (this.dateRangePreset) {
        this.applyPresetWithSelection(this.dateRangePreset, "startDateValue", "endDateValue", "dateRangeYear", "dateRangePeriod");
      }
    },
  },
  methods: {
    async fetchOnFilters() {
      this.DISCIPLINES = this.programValue
          ? this.allDisciplines.filter((item) => item.educationProgramId == this.programValue.id)
          : this.allDisciplines;
    },
    async initiateLookups() {
      this.PRE_SERVICE_LEVELS = await EducLevelEnum;
      this.YEAR_OF_EDUCATION = await YearOfEducEnum.map((item) =>
          item.name === "1st Year 1st Semester" || item.name === "1st Year 2nd Semester"
              ? {...item, name: "1st Year"}
              : item
      );

      this.lookupLoading = true;
      this.allDisciplines = await getDisciplines();
      this.allDisciplines = this.allDisciplines.rows;
      this.DISCIPLINES = this.allDisciplines;
      this.EDUCATIONAL_PROGRAMS = await getEducationalPrograms();
      this.EDUCATIONAL_PROGRAMS = this.EDUCATIONAL_PROGRAMS.rows;
      const universityResponse = await getUniversities();
      this.UNIVERSITIES = (universityResponse.rows && universityResponse.rows.length > 0)
          ? universityResponse.rows.filter((item) => item.isActive === true)
          : null;
      this.lookupLoading = false;
    },
    async fetchMonitoringReports() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;

      let searchParams = "?";
      itemsPerPage > 0 && (searchParams += `page=${page}&pageSize=${itemsPerPage}`);

      this.preServiceLevelValue !== null &&
      (searchParams += "&preServiceLevel=" + this.preServiceLevelValue.replace(/\s/g, ""));
      this.universityValue !== null && (searchParams += "&universityId=" + this.universityValue.id);
      this.programValue !== null && (searchParams += "&educationProgramId=" + this.programValue.id);
      this.disciplineValue !== null && (searchParams += "&disciplineId=" + this.disciplineValue.id);
      this.yearOfEducValue !== null &&
      (searchParams += "&entryYear=" + ((this.currentYear - this.yearOfEducValue.id) ?? this.currentYear));
      this.maleValue !== null && (searchParams += "&noOfMale=" + this.maleValue);
      this.maleComparisonValue !== null && (searchParams += "&signMale=" + this.maleComparisonValue);
      this.femaleValue !== null && (searchParams += "&noOfFemale=" + this.femaleValue);
      this.femaleComparisonValue !== null && (searchParams += "&signFemale=" + this.femaleComparisonValue);
      this.startDateValue !== null && (searchParams += "&startDate=" + this.startDateValue);
      this.endDateValue !== null && (searchParams += "&endDate=" + this.endDateValue);

      const response = await PreServiceReportService.getPreServiceSummary(searchParams);
      if (response) {
        this.monitoringReports = {
          ...response,
          rows: (response.rows || []).map((row) => ({
            ...row,
            totalCount: Number(row.noOfMale || 0) + Number(row.noOfFemale || 0),
          })),
        };
      } else {
        this.$toast.error(
            "There was a problem fetching monitoring data. Please try again."
        );
      }
      this.loading = false;
    },
  },
};
</script>
